export const SENSOR_COLOR = {
  GREEN: 'rgba(0, 168, 107, 1.0)',
  YELLOW: 'rgba(255, 225, 53, 0.9)',
  ORANGE: 'rgba(255, 153, 68, 1.0)',
  RED: 'rgba(210, 20, 4, 0.9)',
  LIGHT_BLUE: 'rgba(10, 215, 220, 1)',
  BLUE: 'rgba(25, 74, 255, 1)',
  DEEP_BLUE: 'rgba(0, 39, 138, 1)',
};

export const SENSOR_TABLE_RGBA_COLOR = {
  GREEN: 'rgba(0, 168, 107, 1.0)',
  YELLOW: 'rgba(255, 225, 53, 0.9)',
  ORANGE: 'rgba(255, 153, 68, 1.0)',
  RED: 'rgba(210, 20, 4, 0.9)',
  LIGHT_BLUE: 'rgba(10, 215, 220, 1)',
  BLUE: 'rgba(25, 74, 255, 1)',
  DEEP_BLUE: 'rgba(0, 39, 138, 1)',
};

export const SENSOR_MARKER_RGBA_COLOR = {
  GREEN: 'rgba(0, 168, 107, 0.5)',
  YELLOW: 'rgba(255, 225, 53, 0.7)',
  ORANGE: 'rgba(255, 153, 68, 0.7)',
  RED: 'rgba(210, 20, 4, 0.6)',
  LIGHT_BLUE: 'rgba(10, 215, 220, 0.7)',
  BLUE: 'rgba(25, 74, 255, 0.7)',
  DEEP_BLUE: 'rgba(0, 39, 138, 0.7)',
};

export const TEMPERATURE_RGBA_COLOR = {
  GREEN: '#00B573',
  YELLOW: '#FFE135',
  ORANGE: '#FFA14F',
  RED: '#E16A7C',
  LIGHT_BLUE: '#6CC2BD',
  BLUE: '#5B98E6',
  DEEP_BLUE: '#3A4EA3',
};

export const HUMIDITY_RGBA_COLOR = {
  GREEN: '#00B573',
  YELLOW: '#FFE135',
  ORANGE: '#FFA14F',
  RED: '#E16A7C',
};

export const CARBON_RGBA_COLOR = {
  GREEN: '#00B573',
  YELLOW: '#FFE135',
  ORANGE: '#FFA14F',
  RED: '#E16A7C',
};

export const NOISE_RGBA_COLOR = {
  GREEN: '#00B573',
  YELLOW: '#FFE135',
  ORANGE: '#FFA14F',
  RED: '#E16A7C',
};

export const DEVICE_MARKER_COLOR = {
  MERAKI: '#10b981',
  VERKADA: '#5B98E6',
  BUTLR: '#E16A7C',
  WEBEX: '#FFA14F',
  ARUBA: '#FF8000',
};

export const MEETING_ROOM_STATUS_BG_COLOR = {
  OCCUPIED_BG_COLOR: '#FF6E6E',
  RESERVED_BG_COLOR: '#FFC0C0',
  NOT_FINISH_BG_COLOR: '#FFC0C0',
};

export const CHAT_TOOL_PRESENCE_COLOR = {
  GREEN: '#00B573',
  RED: '#E16A7C',
  YELLOW: '#FFE135',
  ORANGE: '#FFA14F',
  GRAY: '#808080',
};

export const THRESHOLDS_RGBA_COLOR = {
  LIGHT_GREEN: '#00B573',
  GREEN: '#ADDE61',
  YELLOW: '#FFE135',
  ORANGE: '#FFA14F',
  RED: '#E16A7C',
};
